export const MarketPlaceInitialCount = 5;
export const TaxPercent = 8.25;
export const CallCenterApptTableColumns: string[] = ['sn', 'patient', 'doctor', 'reasonForVisit', 'location', 'agent', 'requestedDateTime'];
export const HEALTH_ORGANIZATION_TYPES = [
    { name: 'All', id: 0 },
    { name: 'Non-Profit(510 C)', id: 7 },
    { name: 'Social Services', id: 6 },
    { name: 'Broker Agent', id: 5 },
    { name: 'Employers', id: 4 },
    { name: 'Healthcare & Facilities', id: 3 },
    { name: 'Clinic', id: 2 },
    { name: 'Practice', id: 1 }
]

